// extracted by mini-css-extract-plugin
export default {"input":"E--z","button":"F--z","selected":"G--z","unavailable":"H--z","oos":"I--z","image":"J--z","paperCutDisabledOverlay":"K--z"};